import NodeCache from 'node-cache'

/*
Usage:
const cachedDataService = new CachedDataService({ stdTTL: timeToKeepCacheInSeconds })
cachedDataService.retrieveData(cacheKey, dataRetrievalCallback, ignoreCacheBoolean)
*/

class CachedDataService {
    constructor ({
        stdTTL = 3600,
    } = {}) {
        this.promiseCache = new NodeCache({ stdTTL })
    }

    async retrieveData (key, promiseCallback = () => {}, bypassCache = false) {
        if (bypassCache) {
            this.promiseCache.del(key)
        }
        let promise = this.promiseCache.get(key)
        if (!promise) {
            promise = promiseCallback()
            this.promiseCache.set(key,  promise)
        }
        try {
            return await promise
        } catch (err) {
            this.promiseCache.del(key)
            throw err
        }
    }

    clear () {
        this.promiseCache.flushAll()
    }
}

export default CachedDataService